import React from 'react';
import { useSelector } from 'react-redux';

const Header = () => {
  const { totalCount } = useSelector((state) => state.adminPanelClinics);
  return (
    <div className="adminPanel__header">
      <h5>
        Clinics Of All: <strong>{totalCount}</strong>
      </h5>
    </div>
  );
};

export default Header;
